'use strict';

var util = require('../util/property-util');
var arrayUtil = require('../util/array-util');

module.exports = /*@ngInject*/ ["ProjectResourceService", "$q", "$log", "$rootScope", "$cookies", "$state", function (ProjectResourceService, $q, $log, $rootScope, $cookies, $state) {
    var factory = {};

    var selectedProject;
    var projects;
    var projectsPromise;
    var registeredHandlers = new Map();
    var errorHandlers = new Map();

    factory.getProjects = function () {
        var deferred = $q.defer();
        if (util.isDefined(projects)) {
            deferred.resolve(projects);
            return deferred.promise;
        } else {
            if (!util.isDefined(projectsPromise)) {
                deferred.reject("We need to fetch the projects first");
                return deferred.promise;
            }
            return projectsPromise.$promise.then(
                function (data) {
                    return data;
                }, function (errorMsg) {
                    projects = undefined;
                    $log.warn(errorMsg.status, " ", errorMsg.statusText);
                    if (errorMsg.status === 401) {
                        $cookies.remove('nomad.noc.ng.token');
                        $state.go("login");
                        location.reload();
                    }
                });
        }
    };

    factory.fetchProjects = function () {
        var deferred = $q.defer();
        if (util.isDefined(projects)) {
            deferred.resolve(projects);
            return deferred.promise;
        } else {
            projectsPromise = ProjectResourceService.getAllProjects().query();
            return projectsPromise.$promise.then(function (data) {
                projects = data;
                return data;
            }, function (errorMsg) {
                if (errorMsg.status === 401) {
                    $rootScope.logout();
                }
                projects = undefined;
                $log.warn(errorMsg.status, " ", errorMsg.statusText);
                if (errorMsg.status === 401) {
                    $cookies.remove('nomad.noc.ng.token');
                    $state.go("login");
                    location.reload();
                }
            });
        }
    };

    factory.projectsLoaded = function () {
        return util.isDefined(projects);
    };

    factory.clearAll = function () {
        selectedProject = undefined;
        projects = undefined;
        projectsPromise = undefined;
    };

    /**
     * Subscribe to the projectservice by name
     * the handler gets called when the projectId changes
     * @param name      name to register with
     * @param handler   function
     */
    factory.subscribe = function (name, handler) {
        registeredHandlers.set(name, handler);

        // if we have a selected project, call handler to update the caller
        if (util.isDefined(selectedProject)) {
            handler(selectedProject.id);
        }
    };

    factory.unsubscribe = function (name) {
        registeredHandlers.delete(name);
    };

    factory.subscribeErrorHandler = function (name, handler) {
        errorHandlers.set(name, handler);
    };

    factory.unsubscribeErrorHandler = function (name) {
        errorHandlers.delete(name);
    };

    /**
     * Sets the selected project and propagates the changes to the necessary components
     * @param id        selected project ID
     * @param callerId  the id of the component that is calling this function
     */
    factory.setSelectedProjectById = function (id, callerId) {
        // executes the propagation functions
        return setById(id).then(function (foundProject) {
            selectedProject = foundProject;
            callHandlers(callerId, foundProject.id);
            return foundProject.id;
        }, function (errorMsg) {
            callErrorHandlers(errorMsg);
        });
    };

    factory.setDefaultProject = function (callerId) {
        factory.getProjects().then(function (tmpProjects) {
            if (util.isDefined(tmpProjects) && tmpProjects.length > 0) {
                factory.setSelectedProjectById(tmpProjects[0].id, callerId);
            }
        });
    };

    /**
     * Returns the projectObject by id
     * @param id
     */
    factory.getProjectById = function (id) {
        this.getProjects().then(function (tmpProjects) {
            return arrayUtil.getFirstInList(tmpProjects, "id", id);
        });
    };

    /**
     * Gets the currently selected project
     * @returns selected project object
     */
    factory.getSelectedProject = function () {
        return selectedProject;
    };

    /**
     * Gets the currently selected project id
     * @returns the id of the selected project
     */
    factory.getSelectedProjectId = function () {
        return util.isDefined(selectedProject) ? selectedProject.id : undefined;
    };

    var setById = function (id) {
        return factory.getProjects().then(function (tmpProjects) {
            var found = arrayUtil.getFirstInList(tmpProjects, "id", id);
            if (util.isDefined(found)) {
                return found;
            } else {
                return $q.reject("Invalid project id");
            }
        });
    };

    var callHandlers = function (origin, id) {
        registeredHandlers.forEach(function (value, key) {
            if (key != origin) {
                value(id);
            }
        });
    };

    var callErrorHandlers = function (message) {
        errorHandlers.forEach(function (value, key) {
            value(message);
        });
    };

    return factory;
}];